import { ThumbsUp } from "lucide-react";
import React, { useContext, useState } from "react";
import { Card, Group, ActionIcon, Stack } from "@mantine/core";
import { AnalyticsContext } from "../../../providers/AnalyticsProvider";
import ComingSoonFeature from "../services/models/ComingSoonFeature";

type Props = {
  feature: ComingSoonFeature;
};
const FeatureCard: React.FC<Props> = ({ feature }) => {
  const [response, setResponse] = useState<"up" | "down" | null>(null);

  const { analyticsInstance } = useContext(AnalyticsContext);

  // SEGMENT track feature votes
  const voteForFeature = (vote: boolean): void => {
    if (analyticsInstance) {
      analyticsInstance?.track("coming_soon_feature_feedback", {
        id: feature.id,
        userVoteForFeature: vote,
      });

      setResponse(vote ? "up" : "down");
    }
  };

  return feature.attributes.visible ? (
    <Card
      shadow="xs"
      style={{
        width: "288px",
        padding: "15px 8px",
        borderRadius: "16px",
        boxShadow:
          "0px 3px 8px -1px rgba(50, 50, 71, 0.05), 0px 0px 1px 0px rgba(12, 26, 75, 0.24);",
      }}
    >
      <div style={{ padding: "14px" }}>
        <h3
          style={{
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "24px",
          }}
        >
          {feature.attributes.feature_name}
          <p
            style={{
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
              marginTop: "0",
            }}
          >
            {feature.attributes.feature_category}
          </p>
        </h3>

        <p
          style={{
            fontWeight: 400,
            lineHeight: "20px",
            fontSize: "12px",
            color: "#435366",
          }}
        >
          {feature.attributes.feature_description}
        </p>

        <Stack
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <p
            style={{
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "16px",
              color: "#7A7A9D",
            }}
          >
            Vote for this feature
          </p>
          <Group spacing={0}>
            <ActionIcon
              onClick={() => {
                setResponse("up");
                voteForFeature(true);
              }}
            >
              <ThumbsUp
                size="1.2rem"
                color={response === "up" ? "#007A4D" : "rgb(73, 80, 87)"}
              />
            </ActionIcon>
            <ActionIcon
              onClick={() => {
                setResponse("down");
                voteForFeature(false);
              }}
            >
              <ThumbsUp
                size="1.2rem"
                color={response === "down" ? "#CF1B2B" : "rgb(73, 80, 87)"}
                style={{ transform: "rotate(-180deg)" }}
              />
            </ActionIcon>
          </Group>
        </Stack>

        <p
          style={{
            fontSize: "10px",
            color: response === "down" ? "#CF1B2B" : "#007A4D",
            marginTop: "0",
            display: response === null ? "none" : "block",
          }}
        >
          Thank you for your feedback
        </p>
      </div>
    </Card>
  ) : (
    <div />
  );
};

export default FeatureCard;
